import request from "@/utils/request";
const baseUrl = process.env.VUE_APP_APP_API + "/web/purchase-notice";

function resolveBaseUrl(params = {}) {
  const infoid = params.infoid || params.infoId || "";
  if (infoid.indexOf("nxzc_") === 0) return process.env.VUE_APP_APP_API + "/web/nxzc-notice";
  if (infoid.indexOf("cszc_") === 0) return process.env.VUE_APP_APP_API + "/web/cszc-notice";
  return baseUrl;
}
const purchaseApi = {
  // 公示公告 列表
  page(params) {
    return request({
      url: `${baseUrl}/page`,
      method: "GET",
      params
    });
  },
  // 公告基础信息
  baseInfo(params) {
    const customNotice = /^(nxzc_|cszc_)/.test(params.infoid || "");
    return request({
      url: `${resolveBaseUrl(params)}/get`,
      method: "GET",
      params: customNotice ? { infoid: params.infoid } : params
    });
  },
  // 详细内容
  detail(params) {
    return request({
      url: `${resolveBaseUrl(params)}/getNoticeContent`,
      method: "GET",
      params
    });
  }
};
export default purchaseApi;
